import { useQuery } from "@tanstack/react-query";
import api from "../../../services/api";
import { headerQueryKeys } from "../queryKeys";

export type AnalysisTypeInfo = {
  enabled?: boolean;
  additional_information?: string;
  last_completed_on?: string;
  autoupload?: boolean;
  display_status?: string;
};

export type AnalysisTypes = {
  tc: AnalysisTypeInfo & {
    current_version: string;
  };
  ti_cloud: AnalysisTypeInfo;
  dynamic_analysis: {
    cape: AnalysisTypeInfo;
    cisco_secure_malware_analytics: AnalysisTypeInfo;
    cuckoo: AnalysisTypeInfo;
    fireeye: AnalysisTypeInfo;
    joe: AnalysisTypeInfo;
    rl_auxiliary_analysis: AnalysisTypeInfo;
    rl_dynamic_analysis: AnalysisTypeInfo;
    vmray_tcbase: AnalysisTypeInfo;
  };
};

export const areAdditionalAnalysisTypesAvailable = (
  analysisTypes: AnalysisTypes
) =>
  analysisTypes.dynamic_analysis?.cape?.enabled ||
  analysisTypes.dynamic_analysis?.cisco_secure_malware_analytics?.enabled ||
  analysisTypes.dynamic_analysis?.cuckoo?.enabled ||
  analysisTypes.dynamic_analysis?.fireeye?.enabled ||
  analysisTypes.dynamic_analysis?.joe?.enabled ||
  analysisTypes.dynamic_analysis?.vmray_tcbase?.enabled;

const usePrepareReanalyzeData = (hashes: string[] = []) => {
  const prepareReanalyzeQuery = useQuery({
    queryFn: () => api.prepareReanalyze(hashes),
    queryKey: headerQueryKeys.prepareReanalyze(hashes)
  });

  return {
    data: prepareReanalyzeQuery.data?.data as AnalysisTypes,
    isLoading: prepareReanalyzeQuery.isLoading
  };
};

export default usePrepareReanalyzeData;
